import {z} from 'zod';

const PerfectStoreItemSchema = z.object({
  id: z.number().nullable().catch(null),
  targetName: z.string().catch(''),
  targetType: z.string().nullable().catch(null),
  storeCount: z.number().nullable().catch(null),
  percentAchievedTarget: z.number().nullable().catch(null),
  pointsAwarded: z.number().nullable().catch(null),
  status: z.string().nullable().catch(null),
  startDate: z.string().nullable().optional(),
  endDate: z.string().nullable().optional(),
  reportUrl: z.string().nullable().catch(''),
  updatedAt: z.string().nullable().catch(null),
  updatedBy: z.string().catch('')
});

const PerfectStoreResponseSchema = z.object({
  data: z.array(PerfectStoreItemSchema).optional(),
  totalRecords: z.union([z.string(), z.number()]).catch(''),
  totalPages: z.union([z.string(), z.number()]).catch(''),
  currentPage: z.union([z.string(), z.number()]).catch(''),
  pageSize: z.union([z.string(), z.number()]).catch(''),
  sortBy: z.string().catch(''),
  order: z.string().catch('')
});

export const GetFormattedPerfectStoreData = (apiResponse = {}) => {
  const result = PerfectStoreResponseSchema.safeParse(apiResponse);

  if (!result.success) {
    return {};
  }

  const parsed = result.data;

  return {
    data: parsed.data?.map((item) => PerfectStoreItemSchema.parse(item)),
    totalRecords: parsed.totalRecords,
    totalPages: parsed.totalPages,
    currentPage: parsed.currentPage,
    pageSize: parsed.pageSize,
    sortBy: parsed.sortBy,
    order: parsed.order
  };
};
